'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _extends = require('babel-runtime/helpers/extends')['default'];

var _Object$keys = require('babel-runtime/core-js/object/keys')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _reactisForms = require('reactis-forms');

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _reactisModal = require('reactis-modal');

var _EventEmitter = require('../EventEmitter');

var _EventEmitter2 = _interopRequireDefault(_EventEmitter);

var FormDB = (function (_React$Component) {
	_inherits(FormDB, _React$Component);

	_createClass(FormDB, null, [{
		key: 'contextTypes',
		value: {
			store: _react2['default'].PropTypes.object,
			user: _react2['default'].PropTypes.object.isRequired
		},
		enumerable: true
	}]);

	function FormDB(props, context) {
		_classCallCheck(this, FormDB);

		_React$Component.call(this, props);
		this.changed = !props.id;
		this.title = false;
		this.user = context.user;
	}

	FormDB.prototype.componentDidMount = function componentDidMount() {
		if (!this.props.form || !this.props.form.get('loaded')) {
			this.load();
		}
	};

	FormDB.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
		if (nextProps.id != this.props.id || nextProps.tabid != this.props.tabid || nextProps.form != this.props.form) {
			return true;
		}
		return false;
	};

	FormDB.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
		var newTab = {};
		if (nextProps.tab.title != this.title && this.title) {
			newTab.title = this.title;
		}
		if (nextProps.tab.unsave != this.changed) {
			newTab.unsave = this.changed;
		}
		if (_Object$keys(newTab).length > 0) {
			this.props.updateTab(newTab);
		}
	};

	FormDB.prototype.load = function load() {
		var _this = this;

		if (this.props.id) {
			this.props.actions.load('tab_' + this.props.tabid, this.api.fetch, { id: this.props.id }).then(function (a) {
				_this.changed = false;
				//this.form.storeCheckpoint();
				if (a.error && a.error.code == 404) {
					alert(_this.messages.notfound);
					_this.props.closeTab();
				} else {
					_this.updateTab(a.result);
				}
			});
		}
	};

	FormDB.prototype.getFormData = function getFormData() {
		return _extends({}, this.form.getValues().toJS(), { id: this.props.id });
	};

	FormDB.prototype.save = function save() {
		var _this2 = this;

		var close = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];

		var errors = this.refs.form.getWrappedInstance().validate();
		if (errors) {
			this.displayErrors(errors);
		} else {
			var data = this.getFormData();
			this.props.actions.save('tab_' + this.props.tabid, this.api.save, data).then(function (action) {
				if (!action.error) {
					_this2.changed = false;
					_EventEmitter2['default'].emit(_this2.changeEvent);
					_this2.props.updateTab({ data: action.result.id, unsave: false });
					if (close) {
						_this2.props.closeTab();
					} else {
						_this2.forceUpdate();
					}
				} else {
					if (action.error.code == 1001) {
						var _errors = JSON.parse(action.error.message);
						_this2.displayErrors(_errors);
					}
				}
			});
		}
	};

	FormDB.prototype.remove = function remove() {
		var _this3 = this;

		var confirm = new _reactisModal.ConfirmWindow('Potvrzení', this.messages.remove);
		confirm.show(this.context.store.dispatch, function () {
			_this3.props.actions.remove('tab_' + _this3.props.tabid, _this3.api.remove, { id: _this3.props.id }).then(function (action) {
				if (!action.error) {
					_EventEmitter2['default'].emit(_this3.changeEvent);
					_this3.props.closeTab();
				}
			});
		});
	};

	FormDB.prototype.archive = function archive() {
		var _this4 = this;

		var confirm = new _reactisModal.ConfirmWindow('Potvrzení', this.messages.archive);
		confirm.show(this.context.store.dispatch, function () {
			_this4.props.actions.archive('tab_' + _this4.props.tabid, _this4.api.archive, { id: _this4.props.id }).then(function (action) {
				if (!action.error) {
					_EventEmitter2['default'].emit(_this4.changeEvent);
					_this4.props.closeTab();
				}
			});
		});
	};

	FormDB.prototype.active = function active() {
		var _this5 = this;

		var confirm = new _reactisModal.ConfirmWindow('Potvrzení', this.messages.active);
		confirm.show(this.context.store.dispatch, function () {
			_this5.props.actions.active('tab_' + _this5.props.tabid, _this5.api.active, { id: _this5.props.id }).then(function (action) {
				if (!action.error) {
					_EventEmitter2['default'].emit(_this5.changeEvent);
				}
			});
		});
	};

	FormDB.prototype.displayErrors = function displayErrors(errors) {
		var messages = [];
		if (typeof errors != 'string') {
			_Object$keys(errors).forEach(function (key) {
				if (errors[key].childs) {
					errors[key].childs.forEach(function (child) {
						_Object$keys(child.errors).forEach(function (key2) {
							messages.push(child.errors[key2][0]);
						});
					});
				} else {
					messages.push(errors[key][0]);
				}
			});
		} else {
			messages.push(errors);
		}
		var alert = new _reactisModal.AlertWindow('Chyba formuláře', messages.map(function (m) {
			return _react2['default'].createElement(
				'span',
				{ key: m },
				m,
				_react2['default'].createElement('br', null)
			);
		}));
		alert.show(this.context.store.dispatch);
	};

	return FormDB;
})(_react2['default'].Component);

exports['default'] = FormDB;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/FormDB.js
 ** module id = 121
 ** module chunks = 2
 **/